import { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useModal } from 'react-simple-modal-provider';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import VideoButtonPlayIcon from '../components/SvgRobo/VideoButtonPlayIcon';
import VideoRoundIcon from '../components/SvgRobo/VideoRoundIcon';

import CoolLightBox from '../components/CoolLightBox';
import CountDownTimer from '../components/CountDownTimer';
import Card from '../components/Card';
import LinkExternal from '../components/Link/LinkExternal';

import roborovskiSignImg from '../assets/images/roborovski-sign.png';
//import roborovskiImg from '../assets/images/roborovski.png';
import roborovskiX2Img from '../assets/images/roborovski@2x.png';

import badgeAwardImg from '../assets/images/badge/badge-award.svg';
import badgeSignImg from '../assets/images/badge/badge-sign.png';
import badgeSignX2Img from '../assets/images/badge/badge-sign@2x.png';

import mintEmoji1Img from '../assets/images/mint/emoji-1.png';
import mintEmoji2Img from '../assets/images/mint/emoji-2.png';
import mintEmoji3Img from '../assets/images/mint/emoji-3.png';

//import nft0Img from '../assets/images/nft/nft-0.png';
import nft0X2Img from '../assets/images/nft/nft-0@2x.png';
//import nft2Img from '../assets/images/nft/nft-2.png';
import nft2X2Img from '../assets/images/nft/nft-2@2x.png';
//import nft3Img from '../assets/images/nft/nft-3.png';
//import nft3X2Img from '../assets/images/nft/nft-3@2x.png';

import {
  youtubeTeaserUrl, openSeaUrl,
} from '../configs';
import './ScreenFirst.scss';

import * as S from '../store/selectors';



const now = () => Math.trunc(new Date().getTime() / 1000);

function ComponentSoldOut() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  return (
    <div className="main__countdown-item-soldout" style={{ backgroundColor: '#fe5c50' }}>
      <div
        className="main__countdown-item-saleisopen"
        style={isMobile ? { margin: 'auto', width: '30rem', textAlign: 'center', } : { marginLeft: '55px' }}
      >
        <b>SOLD OUT</b>
      </div>
    </div>
  );
}
function ComponentSoldOutAction() {
  return (
    <div className="main__mint">
      <LinkExternal href={openSeaUrl}>
        <div className="main__mint-i">
          <div className="main__mint-row">
            <span>Buy</span> <img src={mintEmoji1Img} alt="" title="" /> ROBO
          </div>
          <div className="main__mint-row">
            <img src={mintEmoji2Img} alt="" title="" /><span>on</span>
          </div>
          <div className="main__mint-row">
            <span>OpenSea</span><img src={mintEmoji3Img} alt="" title="" />
          </div>
        </div>
      </LinkExternal>
    </div>
  );
}


/*function ComponentCommingSoon() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  return (
    <div
      className="main__countdown-item-saleisopen"
      style={isMobile ? { margin: 'auto', width: '30rem', textAlign: 'center', } : { marginLeft: '45px' }}
    >
      <b>COMING SOON</b>
    </div>
  );
}*/
function ComponentSaleIsOpen() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  return (
    <div
      className="main__countdown-item-saleisopen"
      style={isMobile ? { margin: 'auto', width: '30rem', textAlign: 'center', } : { marginLeft: '65px' }}
    >
      <b>SALE IS OPEN</b>
    </div>
  );
}
function ComponentRaffleIsOpen() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  return (
    <div
      className="main__countdown-item-saleisopen"
      style={isMobile ? { margin: 'auto', width: '30rem', textAlign: 'center', } : { marginLeft: '45px' }}
    >
      <b>RAFFLE IS OPEN</b>
    </div>
  );
}
function ComponentPresaleIsOpen() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  return (
    <div
      className="main__countdown-item-saleisopen"
      style={isMobile ? { margin: 'auto', width: '30rem', textAlign: 'center', } : { marginLeft: '45px' }}
    >
      <b>PRESALE IS OPEN</b>
    </div>
  );
}

function ComponentSale() {
  const [time, setTime] = useState(0);
  useEffect(() => {
    setTime(now());
    const intervalId = setInterval(() => {
      setTime(now());
    }, 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, []);

  const timestampPresale = useSelector(S.nft.getTimestampPresale);
  const timestampPresaleEnd = useSelector(S.nft.getTimestampPresaleEnd);
  //const timestampRaffleEnd = useSelector(S.nft.getTimestampRaffleEnd);
  const timestampSale = useSelector(S.nft.getTimestampSale);
  const [state, setState] = useState({
    isPresaleOpen: false, isPresalePaused: false, isSaleOpen: false,
  });
  useEffect(() => {
    setState({
      isPresaleOpen: time >= timestampPresale && time < timestampPresaleEnd,
      isPresalePaused: time >= timestampPresaleEnd && time < timestampSale,
      isSaleOpen: time >= timestampSale,
    })
  }, [time]);

  return (
    <div
      className={(!state.isPresaleOpen && !state.isPresalePaused && !state.isSaleOpen) ? "main__countdown-item" : "main__countdown-item-soldout"}
      style={(!state.isPresaleOpen && !state.isPresalePaused && !state.isSaleOpen) ? {} : { backgroundColor: '#fe5c50' }}
      id={`time-${time}`}
    >
      {!state.isPresaleOpen && !state.isPresalePaused && !state.isSaleOpen && <CountDownTimer />}
      {/*!state.isPresaleOpen && !state.isPresalePaused && !state.isSaleOpen && <ComponentCommingSoon />*/}

      {state.isPresaleOpen && <ComponentPresaleIsOpen />}
      {state.isPresalePaused && <ComponentRaffleIsOpen />}
      {state.isSaleOpen && <ComponentSaleIsOpen />}
    </div>
  );
}
function ComponentSaleAction() {
  const { open: openMintModal } = useModal('MintModal');
  return (
    <div className="main__mint" onClick={openMintModal}>
      <div className="main__mint-i">
        <div className="main__mint-row">
          <span>Mint</span> <img src={mintEmoji1Img} alt="" title="" />
        </div>
        <div className="main__mint-row">
          <img src={mintEmoji2Img} alt="" title="" /><span>your</span>
        </div>
        <div className="main__mint-row">
          <span>ROBO</span><img src={mintEmoji3Img} alt="" title="" />
        </div>
      </div>
    </div>
  );
}



function ScreenFirst() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  const [state, setState] = useState({ hover: false, hover2: false });

  //const isSoldOut = useSelector(S.nft.getSoldOut);

  return (
    <main className="main-screen" data-aos="fade-up">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-xl-4">
            <div className="main" data-aos="fade-right">
              <div className="main__logo">
                <img
                  className={state.hover ? "animate__animated animate__bounce" : ""}
                  onMouseOver={() => setState({ hover: true })}
                  onMouseOut={() => setState({ hover: false })}
                  width="424" height="80" alt="" title=""
                  src={roborovskiSignImg}
                />
              </div>

              <p className="desc">Take a part of the origin story and the ultimate master plan of a little hamster named Roborovski. Discover this superb collection of NFT artwork.</p>

              {/*<div className="main__countdown">
                {isSoldOut && <ComponentSoldOut />}
                {!isSoldOut && <ComponentSale />}

                {isSoldOut && <ComponentSoldOutAction />}
                {!isSoldOut && <ComponentSaleAction />}
              </div>*/}

              <div className="main__roborovski">
                <img
                  className={state.hover2 ? "animate__animated animate__rubberBand" : ""}
                  onMouseOver={() => setState({ hover2: true })}
                  onMouseOut={() => setState({ hover2: false })}
                  width="240" height="240" alt="" title=""
                  //src={roborovskiImg} srcSet={`${roborovskiX2Img} 2x`}
                  src={roborovskiX2Img}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-3 offset-xl-5">
            <div className="main__lead" data-aos="fade-left">
              <div className="main__lead-actions">
                {isMobile && <CoolLightBox options={{ infinite: false }} >
                  <div className="video__box-btn"
                    data-fancybox=""
                    data-src={youtubeTeaserUrl}
                  >
                    <button className="btn-round"><VideoButtonPlayIcon /></button>
                  </div>
                </CoolLightBox>}

                {isMobile && <img alt="" title="" src={badgeAwardImg} />}

                {/*<div className="howtobuy">
                  <Link to="/howtobuy"><span><i>How to Buy?</i></span></Link>
                </div>*/}
              </div>

              <div className="fcards">
                <Card
                  key="1"
                  className="fcard-1"
                  //poster={nft0Img} posterhd={`${nft0X2Img} 2x`}
                  poster={nft0X2Img}
                //name="Roborovski #3832"
                /*summ="1.76"
                icon1="1"
                icon2="4"*/
                />
                <Card
                  key="2"
                  className="fcard-2"
                  //poster={nft2Img} posterhd={`${nft2X2Img} 2x`}
                  poster={nft2X2Img}
                //name="Roborovski #24"
                /*summ="16.28"
                icon1="2"
                icon2="5"*/
                />
                <Card
                  key="3"
                  className="fcard-3"
                  //poster={nft3Img} posterhd={`${nft3X2Img} 2x`}
                  poster={nft2X2Img}
                //name="Roborovski #24"
                /*summ="16.28"
                icon1="3"
                icon2="6"*/
                />
              </div>
            </div>

            {!isMobile && <div className="main__video" data-aos="fade-down" data-delay="200">
              <CoolLightBox options={{ infinite: false }} >
                <div className="video__box"
                  data-fancybox=""
                  data-src={youtubeTeaserUrl}
                >
                  <div className="video__box-btn">
                    <button className="btn-round"><VideoButtonPlayIcon /></button>
                  </div>
                  <div className="video__box-item rotateAnimate">
                    <div className="video__box-color"></div>
                    <div className="video__box-round"><VideoRoundIcon /></div>
                    <div className="video__box-text">
                      <img
                        width="312" height="312" alt="" title="" className=""
                        src={badgeSignImg}
                        srcSet={`${badgeSignX2Img} 2x`}
                      />
                    </div>
                  </div>
                </div>
              </CoolLightBox>
            </div>}
          </div>
        </div>
      </div>
    </main>
  );
};

export default hot(module)(ScreenFirst);
